import { LOADING_APP, TAB } from '../reducers/app'

export const updateAppLoading = (loading) => {
  return (dispatch) => {
    dispatch({ type: LOADING_APP, data: !!loading })
  }
}

export const change_tab = (tab) => {
  return (dispatch) => {
    dispatch({ type: TAB, tab: tab })
  }
}
